import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.jpg";

const Header = () => {
  return (
    <>
      <style>{`
  .font-header {
  background:  linear-gradient(135deg, rgba(247, 20, 88, 0.8), rgba(254,225,64,0.8));
  color: white;
  height: 50px;
  padding: 0 10px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;             
  z-index: 1000;       
}

  .nav-links a {
    color: white;
    margin-left: 15px;
    text-decoration: none;
    font-weight: 500;
  } 

  .nav-links a:hover {
    text-decoration: underline;
  }

  .logo-title {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .logo {
    height: 60%;       
    max-height: 50px;   
    width: auto;       
    object-fit: contain;
  }
`}</style>

      <div className="font-header">
        <div className="logo-title">
          <img src={Logo} alt="logo" className="logo" />
          <h2>Sharada Hill Modern School</h2>
        </div>

        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/notices">Notices</Link>
          <Link to="/login">Login</Link>

        </div>
      </div>
    </>
  );
};

export default Header;